import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, OnDestroy, Renderer2, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { RolesButtonsService } from '../../services/roles-buttons.service';
import { ThemeService } from '../../services/theme.service';
import { MenuComponent } from '../menu/menu.component';
import { NotificationComponent } from '../notification/notification.component';
import { AuthService } from '../../services/auth-service.service';

@Component({
  selector: 'app-navbar',
  imports: [
    CommonModule,
    RouterModule,
    NotificationComponent,
    NotificationComponent,
    FormsModule,
    MenuComponent,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit, OnDestroy {
  renderer = inject(Renderer2);
  themeService = inject(ThemeService);
  router = inject(Router);
  authService = inject(AuthService);

  currentTheme: 'light' | 'dark' = 'light';

  rolesButtonsService = inject(RolesButtonsService);

  warehouses: { id: number; name: string }[] = [];
  selectedWarehouse: { id: number; name: string } | null = null;

  private sub = this.router.events.pipe(
    filter((e): e is NavigationEnd => e instanceof NavigationEnd)
  ).subscribe(() => this.loadWarehousesFromToken());

  private loadWarehousesFromToken() {
    this.warehouses = this.authService.getWarehouses();
    const storedId = this.authService.getSelectedWarehouseId();
    this.selectedWarehouse = this.warehouses.find(w => w.id === storedId) ?? this.warehouses[0] ?? null;
    if (this.selectedWarehouse) {
      const validStored = storedId != null && this.warehouses.some(w => w.id === storedId);
      if (!validStored) {
        this.authService.setSelectedWarehouseId(this.selectedWarehouse.id);
      }
    }
  }

  onWarehouseChange(wh: { id: number; name: string } | null) {
    const previousId = this.authService.getSelectedWarehouseId();
    this.authService.setSelectedWarehouseId(wh?.id ?? null);
    this.selectedWarehouse = wh ?? null;
    if (wh != null && previousId !== wh.id) {
      this.router.navigate(['/dashboard']);
    }
  }

  compareWarehouse(a: { id: number; name: string } | null, b: { id: number; name: string } | null) {
    return a?.id === b?.id;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  menu = [
    {
      name: 'Início',
      icon: 'bi-house-door',
      route: '/dashboard',
      disabled:
        this.rolesButtonsService.isAccessible('menu.crud') === true
          ? false
          : true,
    },
    {
      name: 'Perfil',
      icon: 'bi-person',
      route: '/settings',
      disabled:
        this.rolesButtonsService.isAccessible('menu.crud') === true
          ? false
          : true,
    },
    {
      name: 'Configurações',
      icon: 'bi-gear',
      route: '/settings/roles',
      disabled:
        this.rolesButtonsService.isAccessible('menu.crud') === true
          ? false
          : true,
    },
  ];

  constructor() {}
  ngOnInit(): void {
    this.initialTheme();
    this.loadWarehousesFromToken();
  }

  onThemeChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.setTheme(value as 'light' | 'dark');
  }

  setTheme(theme: 'light' | 'dark') {
    this.themeService.theme.next(theme);
  }

  private initialTheme() {
    const storedTheme = localStorage.getItem('theme');
    this.currentTheme = storedTheme === 'dark' ? 'dark' : 'light';
    this.setTheme(this.currentTheme);
  }
}
